module.exports = __webpack_public_path__ + "static/media/noble-match-visual.09fb4c33.svg";